import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Banner } from '../_model/banner';

const pathApi = 'Banner';

@Injectable({
  providedIn: 'root',
})
export class BannerService {

  constructor(private http: HttpClient) { }

  get(codigoSecao: string): Observable<Banner[]> {
    return this.http.get<Banner[]>(`${environment.URL_API}/${pathApi}/${codigoSecao}`);
  }
}